import { TrueBase, html, css } from "../TrueBase/TrueBase";
import "../TrueGrid/TrueGrid";

export class TrueDualContent extends TrueBase {
    static get properties() {
        return {
            flipOnMobile: {
                type: Boolean,
            },
            widths: {
                type: Array,
            },
            widthsMd: {
                type: Array,
            },
            maxMediumScreenSize: {
                type: Number,
            },
            repeatWidths: {
                type: Boolean,
            },
            resizeObserver: {
                type: ResizeObserver,
                attribute: false,
            },
            gridLoaded: {
                type: Boolean,
                reflect: false,
                attribute: false,
            },
        };
    }

    constructor() {
        super();
        this.widths = [6, 6];
        this.widthsMd = [];
        this.maxMediumScreenSize = 1024;
    }
    connectedCallback() {
        super.connectedCallback && super.connectedCallback();
        this.resizeObserver = new ResizeObserver(
            this._handleSizeAvailable.bind(this)
        );
        this.resizeObserver.observe(this);
    }
    disconnectedCallback() {
        this.resizeObserver.unobserve(this);
    }
    _handleSizeAvailable() {
        if (!this.gridLoaded) {
            this.gridLoaded = true;
        } else {
            this.setWidths();
        }
    }

    firstUpdated() {
        if (typeof this.columnsPerRow !== "undefined") {
            this.style.setProperty("--columns-per-row", this.columnsPerRow);
        }
        this.setWidths();
    }

    updated(changedProperties) {
        changedProperties.forEach((oldValue, propName) => {
            if (propName === "columnsPerRow") {
                this.style.setProperty("--columns-per-row", this.columnsPerRow);
            }

            if (propName === "widths") {
                this.setWidths();
            }
        });
    }

    setWidths() {
        if (this.widths.length > 0) {
        let w = this.widths;
        if (this.widthsMd.length > 0) {
            if (window.visualViewport.width < this.maxMediumScreenSize) {
                w = this.widthsMd;
            } else {
                w = this.widths;
            }
        }

        let slots = this.shadowRoot.querySelectorAll("slot");
        let nodes = [];
        slots.forEach((n, i) => {
            nodes.push(n.assignedNodes()[0]);
        });

        if (nodes.length > 0) {
            nodes.forEach((n, i) => {
                n.style.setProperty(
                    "grid-column",
                    `span ${this.repeatWidths ? w[i % w.length] : w[i]}`
                );
            });
        }
        }

    }

    render() {
        return html`
      <true-grid columnsPerRow="12" gap>
        <slot name="left"></slot>
        <slot name="right"></slot>
      </true-grid>
    `;
    }

    static get styles() {
        return [
            super.styles,
            css`
        :host {
          display: block;
          border-radius: var(--dual-content-border-radius, 0px);
          border: var(--dual-content-border, none);
          overflow: hidden;
          --grid-margin-top: 0;
        }

        true-grid {
          height: 100%;
        }

        ::slotted([slot="left"]),
        ::slotted([slot="right"]) {
          position: relative;
          box-sizing: border-box;
        }

        ::slotted(*) {
          min-height: var(--dual-content-image-height, 400px);
        }

        @media screen and (max-width: 768px) {
          ::slotted(*) {
            min-height: calc(var(--dual-content-image-height, 400px) / 2);
          }
        }

        @media screen and (-ms-high-contrast: active),
          screen and (-ms-high-contrast: none) {
          /* IE10+ specific styles go here */
          true-image-responsive,
          true-image,
          div {
            min-height: var(--dual-content-image-height, 400px);
            height: 100%;
          }

          true-grid ::slotted(*) {
            max-width: 50%;
            margin: 0;
          }
        }

        @media screen and (max-width: 768px) {
          :host([flipOnMobile]) true-grid {
            display: flex;
            flex-direction: column-reverse;
          }
        }
      `,
        ];
    }
}

window.customElements.get("true-dual-content") ||
    window.customElements.define("true-dual-content", TrueDualContent);
